<!--
@deprecated use <AppSelectUser/> instead
-->

<template>
    <AppDropdown
        :id="componentId"
        :data="membersData"
        @select="setMember"
        :disabled="disabled"
        :align="dropdownAlign"
        :stopPropagation="stopPropagation"
        :search="{ show: true, property: 'fullName', caseSensitive: false }"
        :showMenuButton="showMenuButton"
        :withQuillModuleEvents="withQuillModuleEvents">

        <template slot="menu-button">

            <!-- default -->
            <slot name="menu-button" v-if="assignedUser || showUnassigned">
                <div v-if="!assignedUser" class="w-100 text-left">
                    <span v-tooltip.top="assignedUserFullName || 'Not assigned'" class="emptyIconCircle text-center">
                        <i class="fal fa-user"></i>
                    </span>
                </div>
                <div v-if="assignedUser" class="position-relative d-inline-block">
                    <avatar v-tooltip.top="assignedUserFullName || 'Not assigned'"
                            :size="31"
                            :inline="true"
                            :customStyle="{ 'vertical-align': 'middle' }"
                            :src="assignedUserAvatar"
                            :username="assignedUserFullName"/>
                    <div v-if="uuid !== userUUID && membersPresence[uuid]" v-tooltip="'Online'"
                         class="is-online-user"></div>
                </div>

                <div v-if="withRightCaption" class="d-inline-block ml-2 text-dark">
                    {{ assignedUserFullName }}
                </div>
            </slot>

        </template>

        <template #item="{ item }">
            <div class="media text-left">
                <div class="position-relative mr-2">
                    <avatar
                        :username="getUserFullName(item)"
                        :size="24"
                        :src="membersAvatars[item.uuid]">
                    </avatar>
                    <div v-if="item.uuid !== userUUID && membersPresence[item.uuid]"
                         v-tooltip="'Online'" class="is-online-user">
                    </div>
                </div>

                <div class="media-body align-self-center pr-1"
                     :class="{ 'text-bold': assignedUser && assignedUser.uuid === item.uuid }">
                    {{ getUserFullName(item) }}
                </div>
            </div>
        </template>

    </AppDropdown>
</template>

<script>
import {mapGetters} from 'vuex'
import {getUserFullName} from '@/utils/user'
import {UNASSIGNED} from '@/types/data'

export default {
    name: 'AppAssignUser',
    props: {
        componentId: {
            type: String,
            default: () => 'assign-' + Math.random()
        },
        uuid: { // current user uuid
            required: true
        },
        users: {
            required: false
        },
        showMenuButton: {
            type: Boolean,
            default: true
        },
        withQuillModuleEvents: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        stopPropagation: {
            type: Boolean,
            default: false
        },
        dropdownAlign: {
            type: String,
            default: 'left'
        },
        withUnassign: {
            type: Boolean,
            default: true
        },
        showUnassigned: {
            type: Boolean,
            default: true
        },
        withRightCaption: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            getUserFullName
        }
    },
    computed: {
        ...mapGetters([
            'getMembers',
            'getActiveMembers',
            'userUUID',
            'membersAvatars',
            'membersPresence'
        ]),

        membersData() {
            let data = []
            if (this.users) {
                data = this.users
            } else {
                data = [...this.getActiveMembers]
            }
            if (this.withUnassign) {
                data.push({uuid: UNASSIGNED, firstName: 'Unassign', lastName: ''})
            }
            return data.map(item => ({...item, fullName: getUserFullName(item)}))
        },

        assignedUser() {
            return this.getMembers.find(user => user.uuid === this.uuid)
        },

        assignedUserFullName() {
            return getUserFullName(this.assignedUser)
        },

        assignedUserAvatar() {
            if (!this.assignedUser) {
                return ''
            }
            return this.membersAvatars[this.uuid]
        }
    },
    methods: {
        setMember(member) {
            this.$emit('change', member)
        }
    }
}
</script>

<style lang="scss" scoped>
.is-online-user {
    position: absolute;
    background-color: $color-success;
    top: 0;
    right: 0;
    width: 7px;
    height: 7px;
    border-radius: 50%;
}
</style>
